import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "button" }
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = {
  key: 1,
  class: "icon"
}
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_6 = { class: "dropdown-content" }
const _hoisted_7 = { class: "scrollable-item-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "item-title" }
const _hoisted_10 = {
  key: 1,
  class: "dropdown-divider"
}
const _hoisted_11 = {
  key: 2,
  class: "dropdown-item item-group-heading"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "item-title" }

import { InputVariableViewModel } from '@/features/bots/models/designer';
import AddNewVariableModal from './AddNewVariableModal.vue';
import { dropDownHelper } from '@/shared/components/dropDownMenu/dropDownHelper';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import Icon from '@/shared/icons/Icon.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import AttributeIconUtil from '@/shared/util/attributeIconUtil';
import { ContactAttributeType } from '@/messaging/models/contactAttributeType';
import CreateAttribute from '@/features/settings/components/CreateAttribute.vue';
import { computed, nextTick, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'VariablePicker',
  props: {
  value: {
    type: Object as PropType<InputVariableViewModel>,
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  direction: {
    type: String as PropType<'left' | 'right'>,
    default: 'right',
  },
  open: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  additionalAttributes: {
    type: Array as PropType<InputVariableViewModel[]>,
    default: [],
  },
},
  emits: ["variable-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const flowVariables = computed(() => store.getters.flowVariables);
const contactAttributes = computed<ContactAttributeViewModel[]>(() => store.getters.contactAttributes);
const getAttribute = (attributeId: string) => computed(() => store.getters.getAttribute(attributeId));

const selected = ref<InputVariableViewModel>({
  id: '',
  key: '',
  name: '',
  scope: '',
});
const isOpen = ref(false);
const showNewVariableModal = ref(false);
const showCreateAttributeModal = ref(false);
const isUp = ref(false);

const contactVariables = computed(() => {
  const filtered = contactAttributes.value
    .filter((attr: ContactAttributeViewModel) => attr.type !== ContactAttributeType.Date)
    .map(
      (attr: ContactAttributeViewModel) =>
        ({
          id: (attr.system ? 'appUser.' : 'appUser.customAttributes.') + attr.id,
          scope: attr.system ? 'appUser' : 'appUser.customAttributes',
          key: attr.id,
          name: attr.name,
          dataType: attr.type,
        }) as InputVariableViewModel,
    );

  if (props.additionalAttributes) {
    filtered.unshift(...props.additionalAttributes);
  }
  return filtered;
});

watch(
  () => props.value,
  (value: InputVariableViewModel | undefined) => (selected.value = value || ({} as InputVariableViewModel)),
  { immediate: true },
);

watch(
  () => props.open,
  (value: boolean) => {
    isOpen.value = value;
    positionDropdown();
  },
  { immediate: true },
);

function getIconComponent(variable: InputVariableViewModel) {
  return AttributeIconUtil.getIconType(variable.dataType, variable.key, isSystemAttribute(variable.key));
}

function isFlowVariableSelected() {
  return selected.value?.scope === 'flow';
}

function isAppUserVariableSelected() {
  return selected.value?.scope && selected.value.scope.startsWith('appUser');
}

const buttonLabel = computed(() => selected.value?.name || 'Choose a variable...');

function chooseVariable(variable: InputVariableViewModel) {
  selected.value = variable;
  emit('variable-selected', selected.value);
}

function closePicker() {
  isOpen.value = false;
  isUp.value = false;
}

function togglePicker() {
  isOpen.value = !isOpen.value;
  positionDropdown();
}

function variableAdded(newVar: InputVariableViewModel) {
  chooseVariable(newVar);
  closeModal();
}

function openNewVariableModal() {
  showNewVariableModal.value = true;
}

function closeModal() {
  showNewVariableModal.value = false;
}

function getTopDistance() {
  if (isUp.value && !props.showButton) {
    return '-27px';
  } else if (!isUp.value && !props.showButton) {
    return '4px';
  }
  return '0px';
}

function openNewAttributeModal() {
  showCreateAttributeModal.value = true;
}

function closeAttributeModel(newAttribute?: ContactAttributeViewModel) {
  showCreateAttributeModal.value = false;
  if (newAttribute) {
    const variableForNewAttribute = contactVariables.value.find(
      (attr: InputVariableViewModel) => attr.key === newAttribute.id,
    );
    if (variableForNewAttribute && variableForNewAttribute.dataType !== ContactAttributeType.Date) {
      chooseVariable(variableForNewAttribute);
    }
  }
}

function isSystemAttribute(variableId: string) {
  const attribute = getAttribute(variableId).value;
  return attribute ? attribute.system : false;
}

function positionDropdown() {
  nextTick(() => (isUp.value = dropDownHelper.isDropDownUp()));
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", {
        'is-active': isOpen.value,
        'is-up': isUp.value,
        'is-left': __props.direction === 'left',
        'is-right': __props.direction === 'right',
      }]),
      style: _normalizeStyle({ top: getTopDistance() })
    }, [
      (__props.showButton)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "dropdown-trigger",
            onClick: togglePicker
          }, [
            _createElementVNode("button", _hoisted_1, [
              (isFlowVariableSelected())
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(Icon, { icon: "FlowVariableIcon" })
                  ]))
                : _createCommentVNode("", true),
              (isAppUserVariableSelected())
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(Icon, {
                      icon: getIconComponent(selected.value)
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(buttonLabel.value), 1),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, { icon: "angle-down" })
              ])
            ])
          ])), [
            [_directive_click_away, closePicker]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown-item item-group-heading" }, [
              _createElementVNode("span", null, "Contact")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactVariables.value, (variable) => {
              return (_openBlock(), _createElementBlock("a", {
                onClick: ($event: any) => (chooseVariable(variable)),
                class: "dropdown-item",
                key: variable.id
              }, [
                _createVNode(Icon, {
                  icon: getIconComponent(variable)
                }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(variable.name), 1)
              ], 8, _hoisted_8))
            }), 128)),
            (!__props.readonly)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  id: "add-attribute",
                  onClick: openNewAttributeModal,
                  class: "dropdown-item add-item"
                }, [
                  _createVNode(AddIcon),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "item-title" }, "Add new attribute", -1))
                ]))
              : _createCommentVNode("", true),
            (!__props.readonly || flowVariables.value.length > 0)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_10))
              : _createCommentVNode("", true),
            (!__props.readonly || flowVariables.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "Flow", -1)
                ])))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowVariables.value, (variable) => {
              return (_openBlock(), _createElementBlock("a", {
                onClick: ($event: any) => (chooseVariable(variable)),
                class: "dropdown-item",
                key: variable.id
              }, [
                _createVNode(Icon, { icon: "FlowVariableIcon" }),
                _createElementVNode("span", _hoisted_13, _toDisplayString(variable.name), 1)
              ], 8, _hoisted_12))
            }), 128)),
            (!__props.readonly)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  id: "add-variable",
                  onClick: openNewVariableModal,
                  class: "dropdown-item add-item"
                }, [
                  _createVNode(AddIcon),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "item-title" }, "Add new variable", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!__props.showButton && isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({ 'arrow-down': isUp.value, 'arrow-up': !isUp.value })
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "inner-arrow" }, null, -1)
          ]), 2))
        : _createCommentVNode("", true)
    ], 6),
    (showNewVariableModal.value)
      ? (_openBlock(), _createBlock(AddNewVariableModal, {
          key: 0,
          onAdded: variableAdded,
          onClose: closeModal
        }))
      : _createCommentVNode("", true),
    (showCreateAttributeModal.value)
      ? (_openBlock(), _createBlock(CreateAttribute, {
          key: 1,
          "excluded-data-types": [_unref(ContactAttributeType).Date],
          onCancel: closeAttributeModel,
          onCreate: closeAttributeModel
        }, null, 8, ["excluded-data-types"]))
      : _createCommentVNode("", true)
  ]))
}
}

})